import React from 'react';

function MenuUserImage(props) {
  const { letters } = props;

  const styles = {
    background: 'linear-gradient(135deg, #6366f1 0%, #ec4899 100%)',
    color: '#ffffff',
    width: '80px',
    height: '80px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '2rem',
    fontWeight: '800',
    borderRadius: '50%',
    boxShadow: '0 4px 15px rgba(99, 102, 241, 0.4)',
    textShadow: '0 2px 4px rgba(0,0,0,0.2)',
    border: '2px solid rgba(255,255,255,0.2)'
  };

  return (
    <div style={styles}>
      {letters}
    </div>
  );
}

export default MenuUserImage;
